import axios from 'axios';

let serviceModule = (function() {
    const baseURL = window.location.origin,
    request = axios.create({
        baseURL
    });
    let config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        params: {
            "token": document.getElementsByName('cmb-api-token')[0].content,
            "token_name": "cmb-auth"
        }
    },
    transactionsToken,
    env;

    function clearParamsAndData() {
        config.params = {
            "token": "Pr0Ff3$$!oN@L3",
            "token_name": "cmb-auth"
        }
        config.data = null;
    }

    function clearTokenParams() {
        config.params = {
            "token": "",
            "token_name": ""
        }
    }
    
    switch(baseURL) {
        case 'https://fda-insurance.prod01.sydney.platformos.com':
        case 'https://insurance.familydaycare.com.au':
            transactionsToken = '933fdb6661f26db6bdd15bab3bdf602c'
            break;
        default:
            //transactionsToken = 'ec05a3130c77cde90ccdcb3796c9dc77'
            transactionsToken = 'bed04d5101691c6b6550220c870d6539'
            break;
    }

    switch(window.location.origin) {

        case 'https://fda-insurance.prod01.sydney.platformos.com':
        case 'https://insurance.familydaycare.com.au':
            env = 'prod';
            break;
        default:
            env = 'staging';
            break;
    }
    
    const httpRequest = (method, url, payload) =>
        request[method](url, payload)
            .then(data => ({ state: true, result: data }))
            .catch(err => ({ state: false, result: err }));
    return {
        
        transactionsToken() {
            return transactionsToken;
        },

        environment() {
            return env;
        },

        siteSettings: { 

            get() {
                clearParamsAndData();
                return request.get('main/get_global_site_settings.json', config);
            }

        },

        elantis: {

            createOrderAndPayment($payload) {
                clearParamsAndData();
                config.data = $payload;
                return request.post('api/fdca/quote/create-order-and-payment.json', $payload);
            }

        },

        policy: {

            getByUserType: function($user_type) {
                clearParamsAndData();
                config.params.target = "policies_by_user_type";
                config.params.user_type = $user_type;
                return request.get('main/get.json', config);
            },

            getById: function($id) {
                clearParamsAndData();
                config.params.id = $id;
                return request.get('main/get_policies_by_policy_id.json', config);
            },

            getByNumber: function($policy_no) {
                clearParamsAndData();
                config.params.policy_no = $policy_no;
                return request.get('main/get_policies_by_policy_no.json', config);
            },

            add: function($payload) {
                clearParamsAndData();
                config.data = $payload;
                return request.post('/main/add_policies.json', $payload);
            }
            
        },

        session: {

            getByUserId: function($user_id) {
                clearParamsAndData();
                config.params.target = "session_by_user_id";
                config.params.user_id = $user_id;
                return request.get('main/get.json', config);
            },
            
            get: function($id) {
                clearParamsAndData();
                config.params.target = "session";
                config.params.id = $id;
                return request.get('main/get.json', config);
            },

            add: function($payload) {
                config.data = $payload;
                return httpRequest('post', `${baseURL}/api/fdca/cfw/session/create_update`, $payload);
            },

            update: function($payload) { 
                clearParamsAndData();
                config.data = $payload;
                return request.put('main/update_sessions.json', $payload);
            },

            getSessionDetailsById: function($payload) {
                clearTokenParams();
                config.data = $payload;
                return request.put('api/fdca/cfw/session/get_session_by_user_id', $payload);
            },

            addNewSession: function($payload) {
                clearTokenParams();
                config.data = $payload;
                return request.post('api/fdca/cfw/session/create_update.json', $payload);
            },

            updateSession: function($payload) {
                clearTokenParams();
                config.data = $payload;
                config.params.id = $payload.id;
                return request.post('api/fdca/cfw/session/create_update.json', $payload);

            }

        },

        quotes: {

            get: function($id) {
                clearParamsAndData();
                config.params.target = "quotes";
                config.params.id = $id;
                return request.get('main/get.json', config);
            }

        },

        orders: {

            getAll: function($params) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                if($params) {
                    config.params.page = $params.page ? $params.page : '';
                    config.params.size = $params.size ? $params.size : '';
                    config.params.keyword = $params.keyword ? $params.keyword : '';
                    config.params.dateFrom = $params.dateFrom ? $params.dateFrom : '';
                    config.params.dateTo = $params.dateTo ? $params.dateTo : '';
                    config.params.sortBy = $params.sortBy ? $params.sortBy : '';
                    config.params.sortOrder = $params.sortOrder ? $params.sortOrder : '';
                }
                return request.get('/insites/api/transactions/internal/get-orders.json', config)
            },
            
            createInsitesModulesOrders: function($payload) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                config.data = $payload;
                return request.post('/insites/api/transactions/internal/create-order.json', $payload, { headers: config.headers })
            },

            updateInsitesModulesOrders: function($payload) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                config.data = $payload;
                return request.post('/insites/api/transactions/internal/update-order.json', $payload, { headers: config.headers })
            }

        },

        crm: {

            createCompanyAndUser: function($payload) {
                clearParamsAndData();
                config.data = $payload;
                let url = "/utilities/create_update_contact_company.json"
                return request.post(url, $payload, { headers: config.headers })
            },

            getCreateCompanyAndUserResponse: function($payload) {
                clearParamsAndData();
                config.data = $payload;
                let url = "/utilities/get_step_function_response.json";
                return request.post(url, $payload, { headers: config.headers })
            },

            getCompanyByName: function($company_name) {
                clearParamsAndData();
                config.params.company_name = $company_name;
                return request.get('main/get_company_by_company_name.json', config);
            },

            getCustomerByEmail: function($params) {
                if($params) {
                    clearTokenParams()
                    config.params.email = $params.email 
                }
                return httpRequest('get', `${baseURL}/api/fdca/cfw/customer/check_email_if_exist.json`, config);
            },
            
        },

        company: {

            get($id) {
                clearParamsAndData();
                return request.get(`main/get_company.json?id=${$id}`, config)
            }

        },

        payments: {

            getAll($params) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                if($params) {
                    config.params.page = $params.page ? $params.page : '';
                    config.params.size = $params.size ? $params.size : '';
                    config.params.keyword = $params.keyword ? $params.keyword : '';
                    config.params.dateFrom = $params.dateFrom ? $params.dateFrom : '';
                    config.params.dateTo = $params.dateTo ? $params.dateTo : '';
                    config.params.sortBy = $params.sortBy ? $params.sortBy : '';
                    config.params.sortOrder = $params.sortOrder ? $params.sortOrder : '';
                    config.params.order_id = $params.order_id ? $params.order_id : '';
                }
                return request.get('/insites/api/transactions/internal/get-payments.json', config)
            },

            createInsitesModulesPayments: function($payload) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                config.data = $payload;
                return request.post('/insites/api/transactions/internal/create-payment.json', $payload, { headers: config.headers })
            },

            updateInsitesModulesPayments: function($payload) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                config.data = $payload;
                return request.post('/insites/api/transactions/internal/update-payment.json', $payload, { headers: config.headers })
            }

        },

        creditCards: {

            get($id) {
                clearParamsAndData();
                config.params.id = $id;
                return request.get('main/get_credit_cards_by_user_id.json', config);
            },

            delete($id) {
                clearParamsAndData();
                return request.delete(`main/delete_stripe_card.json?id=${$id}`);
            }

        },

        stripe: {

            createPayment($payload) {
                clearParamsAndData();
                config.headers['Authorization'] = transactionsToken;
                config.data = $payload;
                return request.post('api/fdca/quote/payment/create-payment.json', $payload);
                // return request.post('https://44g5aw0nd1.execute-api.ap-southeast-1.amazonaws.com/Stg/fdca-insurance-create-stripe-charge', $payload);
            },

            createUser($payload) {
                clearParamsAndData();
                config.data = $payload;
                return request.post('/insites/api/create-customer.json', $payload);
            }

        }
        
    }
})();

window.serviceModule = serviceModule;